module.exports = __webpack_public_path__ + "static/media/404truck.d6bbbb22.svg";